function splitWords (input: string | null | undefined): string[] {
  return String(input ?? '')
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    .replace(/[-_.\s/]+/g, ' ')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w.toLowerCase())
}

export function pascalCase (input: string | null | undefined): string {
  return splitWords(input)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join('')
}

export function camelCase (input: string | null | undefined): string {
  const words = splitWords(input)
  if (words.length === 0) return ''
  return words[0] + words.slice(1).map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join('')
}
